import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Twilio Send SMS v1 Configuration Validator
 * Validates Twilio SMS configuration including connection and message content
 */
export const Twilio_Send_Sms_1_ConfigValidator = z.object({
    twilioConnection: requiredString('Twilio Connection is required'),
    smsTo: requiredString('To Phone Number is required'),
    smsBody: requiredString('SMS Message is required')
});
//# sourceMappingURL=twilio-send-sms-1.js.map